export default __webpack_public_path__ + "static/701-05f76edfa3a4769e90dae70a158e4491.gif";